<template>
  <div class="designtool" >
    <el-container style="height: 100%" direction="vertical">
      <!--设计工具头部-->
      <el-header>
         <the-hander></the-hander>
      </el-header>
      <el-container>
        <!--设计工具左侧-->
        <el-aside width="30%">
          <the-aside></the-aside>
        </el-aside>
        <!--设计工具右侧-->
        <el-main>
          <the-main></the-main>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>



<script>
import TheHander from '../pages/ProductInformation/TheHander'
import TheAside from '../pages/ProductInformation/TheAside'
import TheMain from '../pages/ProductInformation/TheMain'
export default {
  name: 'Product',
  components: {
    TheHander,TheAside,TheMain
  },
  data () {
    return {
      isCollapse: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped>
  .designtool{
    height: 100%;
  }
  .designtool>>>.el-header, .el-footer {
    background-image: linear-gradient(-90deg,
    #df110c 0%,
    #df2a00 50%,
    #df5106 100%),
    linear-gradient(
      #27bdff,
      #27bdff);
    color: #333;
    text-align: center;
    line-height: 33px;
    height: 33px !important;
  }
  .el-aside {
    background-color: #b5b5b5;
    color: #333;
    text-align: center;
    padding-right: 5px;
  }
  .el-main {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue